import React, { useEffect } from 'react';
import { PromptCrafter } from '../features/prompt-crafter';
import { trackEvent } from '../shared';

function PromptCrafterPage() {
  useEffect(() => {
    trackEvent('prompt_crafter_opened');
  }, []);

  return <PromptCrafter />;
}

export default PromptCrafterPage;
